export default {"src":"/_next/static/media/location.5201cff1.svg","height":16,"width":14};